import React from "react";
import "./input.css";

const Input = ({ children }) => {
  return <div className='input'>{children}</div>;
};

export default Input;
